// extracted by mini-css-extract-plugin
export default {"container":"section-title_container__1lvpm","colored":"section-title_colored__3GFCR"};